import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DropDown } from '../../../common/dropdown';
import {
  changeWatchList,
  REDUCER_NAME,
  changeSector,
  fetchMyWatchList,
} from '../reducer';
import { I18n } from 'react-redux-i18n';

class Filter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      listWatchListByWatchListId: this.props.listWatchListByWatchListId,
    };
  }

  componentDidMount() {
    const { fetchMyWatchList } = this.props;
    fetchMyWatchList();
  }

  onChangeWatchlist = select => {
    const { changeWatchList } = this.props;
    changeWatchList(select);
  };

  changeSector = select => {
    const { changeSector } = this.props;
    changeSector(select);
  };

  render() {
    const {
      listWatchListId,
      listWatchListByWatchListId,
      watchListId,
      listSectorDropdownByKey,
      listSectorDropdown,
      sectorId,
      comGroupCode,
      icbCode,
    } = this.props;
    const listWatchListNew = listWatchListByWatchListId
      ? {
          ...listWatchListByWatchListId,
          All: {
            ...listWatchListByWatchListId.All,
            text: I18n.t('stockScreener.allExchanges'),
          },
        }
      : {};
    return (
      <div className="float-left screener-filter">
        <div className="list-filter mr-10">
          <div className="line-drop">
            <DropDown
              listKey={listWatchListId}
              listDataByKey={listWatchListNew}
              keyTitle={'text'}
              currentKey={watchListId || comGroupCode}
              change={this.onChangeWatchlist}
              isI18n={true}
            />
          </div>
          <div className="line-drop ml-20 sectors-dropdown">
            <DropDown
              listKey={listSectorDropdown}
              listDataByKey={listSectorDropdownByKey}
              keyTitle={'icbName'}
              currentKey={sectorId || icbCode}
              change={this.changeSector}
              isI18n={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listWatchListId: state[REDUCER_NAME].listWatchListId,
    listWatchListByWatchListId: state[REDUCER_NAME].listWatchListByWatchListId,
    watchListId: state[REDUCER_NAME].comGroupCode,
    listSectorDropdown: state[REDUCER_NAME].listSectorDropdown,
    listSectorDropdownByKey: state[REDUCER_NAME].listSectorDropdownByKey,
    sectorId: state[REDUCER_NAME].icbCode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeWatchList: watchListId => dispatch(changeWatchList(watchListId)),
    changeSector: sectorId => dispatch(changeSector(sectorId)),
    fetchMyWatchList: () => dispatch(fetchMyWatchList()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Filter);
